import { EVENT_TYPE } from "../../../enums/event-type";
export function onInputSearch(event, storeSearchInputBlock) {
  if (event.key === EVENT_TYPE.ENTER) {
    var focusPrediction = storeSearchInputBlock.querySelector('.js-focus-prediction');
    if (focusPrediction) {
      focusPrediction.click();
      storeSearchInputBlock.blur();
    }
  }
}